// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ckip","footer":"styles_footer__28FAf"};